import { Box, Modal } from "@mui/material";
import { nearExpiryLine } from "./pbfInventoryText";

/**
 * Asks before buying checked items with near_expiry (ED within a year).
 * It never blocks: "Lanjutkan" goes on with the purchase.
 */
const NearExpiryConfirmPopup = ({ items, onCancel, onConfirm }) => (
  <Modal open={!!items?.length} onClose={onCancel}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        maxWidth: "90vw",
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: 2,
        p: 3,
      }}
      className="text-left text-[14px] text-[#2C3E5D]"
    >
      <p className="font-bold text-lg mb-2">
        Ada barang dengan ED kurang dari 1 tahun
      </p>
      <ul className="mb-2">
        {items?.map((item) => (
          <li key={item.pbf_product_uuid}>{nearExpiryLine(item)}</li>
        ))}
      </ul>
      <p className="mb-6">Lanjutkan pembelian?</p>
      <div className="flex gap-2 justify-end">
        <button
          type="button"
          className="border border-gray-400 rounded-md py-2 px-4 hover:bg-gray-100"
          onClick={onCancel}
        >
          Batal
        </button>
        <button
          type="button"
          className="text-white bg-[#94C679] rounded-md py-2 px-4 hover:bg-gray-300"
          onClick={onConfirm}
        >
          Lanjutkan
        </button>
      </div>
    </Box>
  </Modal>
);

export default NearExpiryConfirmPopup;
